/* @flow */
import _ from 'lodash';
import EditCollection from './crud/EditCollection';
import ErrorId from './../../protocol/ErrorId';
import {
  AddFavItemsResp,
  CollectionParameter,
  CollectionParametersObject,
  CollectionScope,
  CollectionUserEntry,
  CollectionUsersInfo,
  CreateCollectionLinkQuery,
  CreateLiveDrawMessage,
  CreateLiveDrawQuery,
  CreateLiveDrawResponse,
  FuidRrnInfo,
  GetCollectionFilterListResp,
  GetCollectionFiltersResp,
  GetCollectionMetadataForWebClientQuery,
  GetCollectionMetadataMessage,
  GetCollectionMetadataResponse,
  GetCollectionParametersMessage,
  GetCollectionParametersQuery,
  GetRevisionsOfCollectionAssetResponse,
  GetZmCollectionUsersQuery,
  ListLiveDrawsQuery,
  ListLiveDrawsResponse,
  LiveDrawEntry,
  LiveDrawSpecResponse,
  LsZmCollectionsMessage,
  LsZmCollectionsQuery,
  LsZmCollectionsResponse,
  RepoItem,
  SetCollectionMetadataResponse,
  SimpleResponse,
  ValueList,
  ZmCollection,
  CollMetadata
} from './../../autogenerated/ZoomBridge';
import GetCredentialsQuery from './../../queries/GetCredentialsQuery';
import LsCollections from './LsCollections';
import GetRevisionsOfCollectionAsset from './../compare/GetRevisionsOfCollectionAsset';
import HashMap from './../../protocol/HashMap';
import GetCollectionFilters from './GetCollectionFilters';
import DeleteCollections from './../../queries/lightbox/crud/DeleteCollections';
import ApproveRejectCollection from './ApproveRejectCollection';
import DeleteCollectionMetadata from './metadata/DeleteCollectionMetadata';
import SetCollectionMetadata from './metadata/SetCollectionMetadata';
import DeleteZmCollectionUsers from './userRoles/DeleteZmCollectionUsers';
import EditZmCollectionUserPermission from './userRoles/EditZmCollectionUserPermission';
import ViewUtil from './../../ViewUtil';
import Authenticator from './../../protocol/Authenticator';
import DeleteZmCollectionAssets from './assets/DeleteZmCollectionAssets';
import AddFavItem from './../fav/AddFavItems';
import GetCollectionFilterList from './GetCollectionFilterList';
import GetLiveDrawSpec from './../GetLiveDrawSpec';
import CollectionSettingsUtil from './userRoles/CollectionSettingsUtil';
import { Permissions } from '../../types';
import GetCollectionSettings from '../settings/GetCollectionSettings';
import SetCollectionSettings from '../settings/SetCollectionSettings';
import { COLLECTIONS, COLLECTION_ID, SELECTED_COLLECTION } from '../../store/Constants';
import Store from '../../store/Store';
import t from '../../i18n/I18n';
import { isMobile } from '../../util/ScreenUtil';
import CreateCollection from './crud/CreateCollection';
import CollectionFeature from './CollectionFeature';
import { SUBTAB } from '../../util/Constants';
import PollAndDownloadJob from '../../protocol/PollAndDownloadJob';
import { toast } from '../../store/StoreUtil';
import StringUtil from '../../util/StringUtil';

const debug = require('../../debug/debug')('wc:util:CollectionUtil');

export default class CollectionUtil {
  static ALL_COLLECTION_ID = -1;
  //static DUMMY_COLLECTION_ID = -1000;
  static ROOT_COLLECTION_ID = 0;
  static PAGE_LIMIT = 40;
  static LB_PAGEID = 'LightboxPagingDataIdWebclient';
  static COLLECTION_NAME_KEY = 'COLLECTION_NAMES';
  static TAGS_KEY = 'TAGS';
  static COLLECTION_STATUS_KEY = 'COLLECTION_STATUS';
  static COLLECTION_TYPE_KEY = 'COLLECTION_TYPE';
  static OWNER_KEY = 'OWNER';
  static COLLECTION_PREVIOUS_STATUS_KEY = 'COLLECTION_PREVIOUS_STATUS';
  static COLLECTION_ARCHIVED_KEY = 'ARCHIVED';
  static COLLECTION_APPROVED_KEY = 'APPROVED';
  static COLLECTION_REJECT_KEY = 'REJECTED';
  static COLLECTION_NOT_STARTED_KEY = 'NOT_STARTED';
  static COLLECTION_IN_PROGRESS_KEY = 'IN_PROGRESS';
  static COLLECTION_EXPIRED = 'EXPIRED';
  static COLLECTION_OVERDUE_KEY = 'OVERDUE';
  static MODIFIED_IN_KEY = 'MODIFIED_IN';
  static CREATED_IN_KEY = 'CREATED_IN';
  static EXT_LDAP_REALM = 'ExtLdapRealm';
  static IS_COLLECTION_PERMISSION_ERROR = false;

  static COLLECTION_SORT_CRITERIAS = {
    MODIFIED_TIME: 'COLLECTION_LAST_MODIFIED',
    NAME: 'NAME',
  }

  static SORT_PARAMS = {
    DEFAULT_SORT_CRITERIA: CollectionUtil.COLLECTION_SORT_CRITERIAS.MODIFIED_TIME,
    DEFAULT_SORT_ORDER: 1,
  };

  static ASSET_SORT_PARAMS = {
    DEFAULT_SORT_CRITERIA: 'NAME',
    DEFAULT_SORT_ORDER: 0,
    SORT_CRITERIAS: ['MODIFICATION_TIME', 'NAME', 'KIND']
  };

  static LINK_SHARING_PARAMS = {
    ANYONE_WITH_LINK_READONLY: 1,
    ANYONE_WITH_LINK_COMMENT: 2,
    /*//ANYONE_WITH_LINK_LOGIN_REQUIRED: 3,*/
    INVITE_ONLY: 4,
    DISABLE: 5
  };

  static COLLECTION_PARAMETER_VALUES = {
    NO_RESTRICTIONS: 'NO_RESTRICTIONS',
    LOW_RESOLUTION_DOWNLOADS_ONLY: 'LOW_RESOLUTION_DOWNLOADS_ONLY',
    NO_DOWNLOADS_PERMITTED: 'NO_DOWNLOADS_PERMITTED',
    ANYONE_WITH_LINK_CAN_VIEW: 'ANYONE_WITH_LINK_CAN_VIEW',
    ANYONE_WITH_LINK_CAN_COMMENT: 'ANYONE_WITH_LINK_CAN_COMMENT',
    INVITE_ONLY: 'INVITE_ONLY',
    SHARING_DISABLED: 'SHARING_DISABLED'
  };

  static COLLECTION_PARAM_KEYS = {
    DOWNLOAD: 'PARAM_DOWNLOAD',
    SHARING: 'PARAM_SHARING',
    ACCESS: 'PARAM_ACCESS',
    PASSWORD_PROTECTED: 'PASSWORD_PROTECTED',
    IMPORT_PATH: 'IMPORT_PATH',
    PATH_TO_ADD_ASSETS: 'PARAM_PATH_TO_ADD_ASSETS',
    IS_COLLECTION_TYPE_TOGGLE_ALLOWED: 'IS_COLLECTION_TYPE_TOGGLE_ALLOWED',
    IS_EXTERNAL: 'IS_EXTERNAL_COLLECTION',
    DUE_DATE: 'DUE_DATE',
    COLLECTION_VERSION: 'COLLECTION_VERSION',
    COLLECTION_STATUS: 'COLLECTION_STATUS',
    PROJECT_PATH: 'PROJECT_PATH',
    IS_EXPIRED: 'IS_EXPIRED',
    SEND_NOTIFICATION_TIME: 'SEND_NOTIFICATION_TIME',
    NUMBER_OF_REJECTIONS: 'NUMBER_OF_REJECTIONS',
    RESOLVED_COMMENTS_COUNTS: 'RESOLVED_COMMENTS_COUNTS',
    NUMBER_OF_APPROVALS: 'NUMBER_OF_APPROVALS',
    TOTAL_COMMENTS: 'TOTAL_COMMENTS',
    MY_REVIEW_STATUS: 'MY_REVIEW_STATUS',
    UNREAD_COMMENTS_COUNT: 'UNREAD_COMMENTS_COUNT'
  };

  /**
   * Collection permission name to code
   * Do not change the values. They are same at backend.
   * IN collection : edit change something => EDIT/EDIT_ALL/ADMIN Permission
   * EDIT => You can't delete. You can't remove an asset, you can remove a user.
   * EDIT_ALL means => he can do everything. except, he can't delete the collection.
   * DISTRIBUTE => Invite the people, he view, and comment. apart from that he can't do anything.
   * CONTRIBUTE => ADD asset, add tag, add comment, but can't delete anything.
   * REVIEW => READ, comment also, resolve They are called reviewers.
   */
  static PERMISSIONS = {
    NONE: 1,
    READ: 2,
    CONTRIBUTE: 3,
    //  EDIT: 4,
    //  EDIT_ALL: 5,
    ADMINISTER: 6
  };

  static COLLECTION_SETTINGS = {
    SORT_CRITERIA: 'SORT_CRITERIA',
    SORT_ORDER: 'SORT_ORDER'
  };

  static getBaseCollectionId() {
    return ViewUtil.isBrowseSubTabActive() ? CollectionUtil.ROOT_COLLECTION_ID : CollectionUtil.ALL_COLLECTION_ID;
  }

  /**
     *
     * @param {number} collectionId
     */
  static getCollectionById(collectionId: number): void {
    const message: LsZmCollectionsMessage = new LsZmCollectionsMessage().setCollectionId(collectionId);
    const query: LsZmCollectionsQuery = new LsZmCollectionsQuery();
    query.message = message;
    return query.run(true);
  }

  /**
   *
   * @param {number} collectionId
   * @param {Function.<ZmCollection,ErrorId>} onResult
   */
  static getCollection(collectionId: number, onResult: Function): void {
    const message: LsZmCollectionsMessage = new LsZmCollectionsMessage().setCollectionId(collectionId);
    const query: LsZmCollectionsQuery = new LsZmCollectionsQuery();
    query.message = message;
    query.run(true).then(
      function (lsZmCollectionsResponse: LsZmCollectionsResponse) {
        const collections: Array<ZmCollection> = lsZmCollectionsResponse.getCollections();
        if (_.size(collections) > 0) {
          onResult(collections[0], null);
        } else {
          onResult(null, new ErrorId(-1, t('FAILED_TO_GET_COLLECTION', { COLLECTIONID: collectionId })));
        }
      },
      function (errorId: ErrorId) {
        onResult(null, errorId);
      }
    );
  }

  /**
   * Returns the possible values for Collection Status drop down.
   * @return {Array.<string>}
   * @public
   */
  static getCollectionStatusValues() {
    return [
      CollectionUtil.COLLECTION_ARCHIVED_KEY,
      CollectionUtil.COLLECTION_APPROVED_KEY,
      CollectionUtil.COLLECTION_IN_PROGRESS_KEY,
      CollectionUtil.COLLECTION_REJECT_KEY
    ];
  }

  /**
   * Create an empty collection with the given name.
   * @param name{String}
   * @return {Promise.<Number, ErrorId>}
   */
  static createCollection(name: string, parentId: number, assetEntries: Array<number>): Promise<number, ErrorId> {
    let createCollectionQuery = new CreateCollection(name).setParentId(parentId);
    if (assetEntries && assetEntries.length) {
      for (const assetId of assetEntries) {
        createCollectionQuery.append(assetId);
      }
    }
    return createCollectionQuery.run();
  }

  /**
   * Create an empty bin (collection) with the given name.
   * @param name{String}
   * @param parentId{number}
   * @param groupedCollectionIds{Array<number>}
   * @param childBinIds{Array<number>}
   * @return {Promise.<Number, ErrorId>}
   */
  static createBin(name: string, parentId: number, groupedCollectionIds: Array<number>, childBinIds: Array<number>): Promise<number, ErrorId> {
    return new CreateCollection(name).setParentId(parentId).setBin(true)
      .setNumChildBins(childBinIds ? childBinIds.length : 0)
      .setChildCollectionIds([...childBinIds, ...groupedCollectionIds]).run();
  }

  /**
   *
   * @param collection{ZmCollection}
   * @param name{String}
   * @return {Promise.<Boolean, ErrorId>}
   */
  static renameCollection(collection: ZmCollection, name: string): Promise<boolean, ErrorId> {
    if(collection.isBin())
      return new EditCollection(collection.getCollectionId()).setName(name).setParentId(collection.getParentId()).setBin(true).run();
    else
      return new EditCollection(collection.getCollectionId()).setName(name).run();
  }

  /**
   *
   * @param collection{ZmCollection}
   * @param parentId{number}
   * @return {Promise.<Boolean, ErrorId>}
   */
  static editCollectionParent(collection: ZmCollection, parentId: number): Promise<boolean, ErrorId> {
    return new EditCollection(collection.getCollectionId()).setMoveFromParentId(collection.getParentId()).setParentId(parentId).setBin(collection.isBin()).run();
  }

  /**
   *
   * @param zmCollection{ZmCollection}
   * @return {string} Returns the name of collection.
   */
  static getCollectionName(zmCollection: ZmCollection): ?string {
    return zmCollection ? zmCollection.getName() : undefined;
  }

  static getCollectionUsers() { }

  /**
   * Fetch collection metadata
   * @param {number} collectionId Collection id
   * @param {Array.<string>} specificMetadata Array of metadata to fetch
   * @returns {Promise.<HashMap,ErrorId>} Returns the hashmap of key:string to values:Array<string> or value:string.
   */
  static getMetadata(
    collectionId: number,
    specificMetadata: ?Array<string>,
    singleValue: boolean = false
  ): Promise<HashMap> {
    const query: GetCollectionMetadataForWebClientQuery = new GetCollectionMetadataForWebClientQuery();
    query.message = new GetCollectionMetadataMessage()
      .setCollectionId(collectionId)
      .setSpecificMetadata(specificMetadata);
    return new Promise(function (onSuccess, onError) {
      query
        .run(true)
        .then(function (response) {
          /**
           * @type {GetCollectionMetadataResponse}
           */
          const mdResponse = response;
          let metadata = new HashMap();
          if (mdResponse) {
            /**
             * @type {HashMap}
             */
            const metadataMap: HashMap = mdResponse.getCollectionMetadata();

            if (metadataMap) {
              const keys = metadataMap.keys();
              _.forEach(keys, function (key: string) {
                /**
                 * @type {Array.<string>}
                 */
                const values: ?Array<string> = CollectionUtil.getValuesFromMapOfMetaToValueList(metadataMap, key);
                if (values && values.length > 0) {
                  if (singleValue) {
                    metadata.put(key, values[values.length - 1]);
                  } else {
                    metadata.put(key, values);
                  }
                }
              });
            }
            onSuccess(metadata);
          }
        })
        .catch(function (errorId: ErrorId) {
          onError(errorId);
        });
    });
  }

  /**
   *
   * Returns the available tags for a collections
   * @param {number} collectionId
   * @return {Promise.<Array.<stirng>,ErrorId} Retusn the promise.
   * @public
   */
  static getTags(collectionId: number): Promise<Array<string>> {
    return new Promise(function (onSuccess: Function, onError: Function) {
      CollectionUtil.getMetadata(collectionId, [CollectionUtil.TAGS_KEY], false).then(
        function (response: HashMap) {
          onSuccess(response ? response.get(CollectionUtil.TAGS_KEY) : null);
        },
        function (errorId: ErrorId) {
          onError(errorId);
        }
      );
    });
  }

  /**
   * Returns the list of all tags.
   * It will be used for auto completion or some other purpose.
   * Returns the array of
   * @param {Function.<Array.<string>, ErrorId>} onResults Callback is called with Array of strings, if error occurred then second argument would be of ErrorId type
   */
  static getAllTags(onResults: Function): void {
    new GetCollectionFilterList(true).run().then(
      (resp: GetCollectionFilterListResp) => {
        const filterNames: Array<string> = resp.getCollectionFilterNames();
        const filtersMap: HashMap = new HashMap();
        filterNames.forEach((filterName: string) => {
          filtersMap.put(filterName, 'regex:.*');
        });

        const query = new GetCollectionFilters(filtersMap);
        query.run(true).then(
          function (resp: GetCollectionFiltersResp) {
            let values: ?Array<string> = undefined;
            /**
             * @type {ValueList}
             */
            const map: HashMap = GetCollectionFilters.createMetadaKeyToValuesMapFromResponse(resp);
            if (map) {
              values = map.get(CollectionUtil.TAGS_KEY);
            }

            if (onResults) {
              onResults(values, null);
            }
          },
          function (error: ErrorId) {
            if (onResults) {
              onResults(null, error);
            }
            window.setError(error.toString());
          }
        );
      },
      (error: ErrorId) => {
        window.setError(error.toString());
      }
    );
  }

  /**
   * Finds the metadata key in given HashMap and returns the metadata value associated with it.
   * @param {HashMap} metadataToValueListMap  Map of metadata key to ValueList
   * @param {string} metadataKey Metadata key to get against. it.
   * @return {Array.<stirng>}
   * @public
   */
  static getValuesFromMapOfMetaToValueList(metadataToValueListMap: HashMap, metadataKey: string): ?Array<string> {
    if (metadataToValueListMap) {
      /**
       * @type {ValueList}
       */
      const valueList = metadataToValueListMap.get(metadataKey);
      if (valueList) {
        /**
         * @type Array.<string>
         */
        const values = valueList.getValues();
        return values;
      }
    }
    return null;
  }

  /**
   *
   * @param {FuidRrnInfo} fuidRrnInfo
   * @param {number} collectionId
   * @returns {Promise} repoItems
   */
  static getRevisionInfoForCompare(fuidRrnInfo: FuidRrnInfo, collectionId: number): Promise<Array<RepoItem>> {
    return new GetRevisionsOfCollectionAsset(collectionId, fuidRrnInfo)
      .run(true)
      .then((resp: GetRevisionsOfCollectionAssetResponse) => {
        return resp.getCollectionAssetRevInfoList();
      });
  }

  /**
   * Deletes one or more collection
   * @param {Array.<number>} collectionIds Array of collection ids.
   * @pram {Function.<boolean, ErrorId>}
   */
  static delete(collectionIds: Array<number>, onResult: Function) {
    new DeleteCollections(collectionIds).run(true).then(
      function (resp) {
        /**
         * @type {SimpleResponse}
         */
        const simpleResponse = resp;
        onResult(simpleResponse.isSuccess());
      },
      function (errorId) {
        onResult(false, errorId);
      }
    );
  }

  static deleteTest() {
    CollectionUtil.delete([1, 2, 3], (success, errorId) => {
      console.log('Delete Collections', success, errorId);
    });
  }

  /**
   * Util method to approve or reject collection.
   * @param {Number} collectionId
   * @param {Boolean} approve Set this to true for approve. Set it to false for reject.
   * @param {Function.<Boolean,ErrorId,String>} onResult callback
   * @returns {Promise} success
   */
  static approveOrRejectCollection(collectionId: number, approve: boolean, onResult: Function) {
    return new ApproveRejectCollection(collectionId, approve).run(true).then(
      (resp) => {
        onResult(
          resp.isSuccess(),
          null,
          approve ? CollectionUtil.COLLECTION_APPROVED_KEY : CollectionUtil.COLLECTION_REJECT_KEY
        );
        /*/!**
         * @type {SimpleResponse}
         *!/
         return resp.isSuccess();*/
      },
      (error) => {
        onResult(null, error);
      }
    );
  }

  /**
   *
   * @param collectionId {Number}
   * @param value {String}
   * @param onResult
   */
  static setTag(collectionId: number, value: string, onResult: Function) {
    new SetCollectionMetadata([collectionId])
      .setAppend(true)
      .setMetadata(CollectionUtil.TAGS_KEY, value)
      .run(true)
      .then(
        (resp) => {
          onResult(resp, null);
        },
        (error) => {
          onResult(null, error);
        }
      );
  }

  /**
   *
   * @param collectionId {Number}
   * @param append {boolean}
   * @param hashMap {HashMap}
   * @param onResult {Function<SetCollectionMetadataResponse,ErrorId>}
   */
  static setMetadata(collectionId: number, append: boolean, hashMap: HashMap, onResult: Function) {
    const setMetadata = new SetCollectionMetadata([collectionId]).setAppend(append);
    if (hashMap) {
      hashMap.forEach(function (key, value) {
        setMetadata.setMetadata(key, value);
      });
    }
    setMetadata.run(true).then(
      (resp) => {
        onResult(resp, null);
      },
      (error) => {
        onResult(null, error);
      }
    );
  }

  /**
   *
   * @param collectionId
   * @param currentStatusMap HashMap
   * @return {Promise<SetCollectionMetadataResponse,ErrorId>}
   */
  static archiveCollection(collectionIds: Array<number>, currentStatusMap: HashMap) {
    return new SetCollectionMetadata(collectionIds)
      .setAppend(true)
      .setMetadataMap(currentStatusMap)
      // .setMetadata(CollectionUtil.COLLECTION_STATUS_KEY, CollectionUtil.COLLECTION_ARCHIVED_KEY)
      // .setMetadata(CollectionUtil.COLLECTION_PREVIOUS_STATUS_KEY, currentStatus)
      .run();
  }

  static updateCollectionStatus(collectionId: number, status: string) {
    return new SetCollectionMetadata([collectionId])
      .setAppend(true)
      .setMetadata(CollectionUtil.COLLECTION_STATUS_KEY, status)
      .run();
  }

  static archiveCollectionWithCallback(collectionId: number, currentStatus: string, onResult: Function) {
    const promise = new SetCollectionMetadata([collectionId])
      .setAppend(true)
      .setMetadata(CollectionUtil.COLLECTION_STATUS_KEY, CollectionUtil.COLLECTION_ARCHIVED_KEY)
      .setMetadata(CollectionUtil.COLLECTION_PREVIOUS_STATUS_KEY, currentStatus)
      .run();
    promise.then(
      (result) => onResult(result, null),
      (error) => onResult(null, error)
    );

    /* new SetCollectionMetadata([collectionId]).setAppend(true).setMetadata(CollectionUtil.COLLECTION_STATUS_KEY, CollectionUtil.COLLECTION_ARCHIVED_KEY).run().then(
     resp => {
     onResult(resp, null);
     },
     (error) => {
     onResult(null, error);
     }
     ); */
  }

  static restoreCollection(collectionIds: Array<number>, previousStatusMap: HashMap) {
    return new SetCollectionMetadata(collectionIds)
      .setAppend(true)
      .setMetadataMap(previousStatusMap)
      // .setMetadata(CollectionUtil.COLLECTION_STATUS_KEY, previousStatus)
      .run();
  }

  static testApproveOrRejectCollection() {
    CollectionUtil.approveOrRejectCollection(5, true, (success, error) => {
      if (success) {
        const query = new GetCollectionMetadataForWebClientQuery();
        query.message = new GetCollectionMetadataMessage().setCollectionId(5);
        query.run().then(
          (resp) => {
            console.log(' Get metadata ', resp);
          },
          (error) => {
            console.log(' Get metadata err', error);
          }
        );
      }
    });
  }

  static deleteMetadataValue(cid: number, key: string, value: string, onResult: Function) {
    new DeleteCollectionMetadata(cid)
      .setMetadata(key, value)
      .run(true)
      .then(
        function (resp) {
          onResult(resp, null);
        },
        function (error) {
          onResult(null, error);
        }
      );
  }

  static deleteAllMetadataTags(cid: number, onResult: Function) {
    CollectionUtil.deleteMetadata(cid, CollectionUtil.TAGS_KEY, onResult);
  }

  static deleteMetadata(cid: number, key: string, onResult: ?Function) {
    const promise = new DeleteCollectionMetadata(cid).setDeleteAllMdKeys(key).run(true);

    if (typeof onResult === 'function') {
      promise.then(
        function (resp) {
          onResult(resp, null);
        },
        function (error) {
          onResult(null, error);
        }
      );
    } else {
      return promise;
    }
  }

  static canShowApproveOrRejectButton(text: string) {
    return !CollectionUtil.isArchived(text);
  }

  static canShowArchiveButton(text: string) {
    return !CollectionUtil.isArchived(text);
  }

  static canShowRestoreButton(text: string) {
    return CollectionUtil.isArchived(text);
  }

  static isApproved(text: string) {
    return text === CollectionUtil.COLLECTION_APPROVED_KEY;
  }

  static isRejected(text: string) {
    return text === CollectionUtil.COLLECTION_REJECT_KEY;
  }

  static isArchived(text: string) {
    return text === CollectionUtil.COLLECTION_ARCHIVED_KEY;
  }

  /**
   *
   * @param {Number} collectionId
   * @param {CollectionUserEntry} user
   * @param {Function.<CollectionUserEntry,Boolean,ErrorId>} onResult callback
   */
  static deleteUser(collectionId: number, user: CollectionUserEntry, onResult: Function) {
    new DeleteZmCollectionUsers(collectionId)
      .setUser(user)
      .run(true)
      .then(
        (resp) => {
          onResult(user.getUserId(), resp, null);
        },
        (error) => {
          onResult(user.getUserId(), null, error);
        }
      );
  }

  /**
   *
   * @param {Number} collectionId
   * @param {CollectionUserEntry} user
   * @param {Function.<Boolean,ErrorId>} onResult callback
   */
  static editUserPermission(collectionId: number, oldUser: CollectionUserEntry, prop: CollectionFeature, val: boolean,
    onSuccess: Function, onFailure: Function): void {
    let member = _.cloneDeep(oldUser); //Removed deep cloning here to get it updated in single go itself.
    if (!member.getCollectionFeatures()) {
      member.setCollectionFeatures(new HashMap());
    }
    const collectionFeatures: HashMap<number, boolean> = member.getCollectionFeatures();

    if (prop.id === CollectionFeature.WRITE_COMMENTS.id) {
      if (val === true) {
        collectionFeatures.put(CollectionFeature.CAN_VIEW_ASSETS.id, true);
      }
      else {
        collectionFeatures.put(CollectionFeature.ADMIN.id, false);
      }
      collectionFeatures.put(CollectionFeature.VIEW_COMMENTS.id, val);
    }
    else if (prop.id === CollectionFeature.ADMIN.id) {
      if (val === true) {
        collectionFeatures.put(CollectionFeature.CAN_VIEW_ASSETS.id, val);
        collectionFeatures.put(CollectionFeature.VIEW_COMMENTS.id, val);
        collectionFeatures.put(CollectionFeature.WRITE_COMMENTS.id, val);
        collectionFeatures.put(CollectionFeature.ADD_ASSETS.id, val);
      }
    }
    else if (prop.id === CollectionFeature.CAN_VIEW_ASSETS.id) {
      if (val === false) {
        collectionFeatures.put(CollectionFeature.VIEW_COMMENTS.id, val);
        collectionFeatures.put(CollectionFeature.WRITE_COMMENTS.id, val);
        collectionFeatures.put(CollectionFeature.ADD_ASSETS.id, val);
        collectionFeatures.put(CollectionFeature.ADMIN.id, val);
      }
    }
    else if (prop.id === CollectionFeature.ADD_ASSETS.id) {
      if (val === true) {
        collectionFeatures.put(CollectionFeature.CAN_VIEW_ASSETS.id, true);
      }
      else {
        collectionFeatures.put(CollectionFeature.ADMIN.id, false);
      }
    }
    collectionFeatures.put(prop.id, val);
    new EditZmCollectionUserPermission(collectionId, member).run().then(
      successResp => {
        onSuccess(successResp, member);
      },
      failedResp => {
        onFailure(failedResp);
      }
    );
  }

  /**
   *
   * @param {Number} collectionId
   * @param {CollectionUserEntry} user
   * @param {Function.<Boolean,ErrorId>} onResult callback
   */
  static setUserPermission(collectionId: number, user: CollectionUserEntry, onResult: Function) {
    new EditZmCollectionUserPermission(collectionId, user).run().then(
      (resp) => {
        onResult(user, resp, null);
      },
      (error) => {
        onResult(user, null, error);
      }
    );
  }

  /**
   * Removes the collection from 'window.gs.collections' object
   * Calls window render.
   * @param {number} collectionId
   */
  static removeCollectionFromGlobalStateAndRender(collectionId: number, render: boolean = true) {
    const collections = Store.get(COLLECTIONS);
    if (collections) {
      const currentCount = collections.length;
      const updatedCollections = collections.filter(function (collection) {
        /**
         * @type {ZmCollection}
         */
        const zmCollection = collection;
        return zmCollection.getCollectionId() !== collectionId;
      });
      if (currentCount != updatedCollections.length) {
        CollectionUtil.setCollectionsInGlobalState(updatedCollections, window.gs.collectionsCount - 1);
      }
      if (render) {
        window.render();
      }
    }
  }

  static switchToCollectionView() {
    ViewUtil.switchToCollections();
  }

  /**
   *
   * @param {Array.<ZmCollection>} collections
   * @param {number} totalCount
   */
  static setCollectionsInGlobalState(collections: ?Array<ZmCollection>, totalCount: number) {
    if (totalCount > 0 && Array.isArray(collections)) {
      collections.forEach((c) => {
        if (c && c.getStatus() === null) c.setStatus(CollectionUtil.COLLECTION_NOT_STARTED_KEY);
      });
      //Keep recording collection Count above store the collections so that it reflects on UI
      window.gs.collectionsCount = totalCount;
      Store.put(COLLECTIONS, collections);
    } else {
      window.gs.collectionsCount = 0;
      Store.put(COLLECTIONS, []);
    }
  }

  static setGlobalSortCriteria(sortCriteria: string, sortOder: string) {
    window.gs.collectionTabSortCriteria = sortCriteria;
    window.gs.collectionTabSortOrder = sortOder;
  }

  static getGlobalSortCriteria() {
    return window.gs.collectionTabSortCriteria;
  }

  static getGlobalSortOrder() {
    return window.gs.collectionTabSortOrder;
  }

  static getCollectionAssetGlobalSortCriteria() {
    return window.gs.collectionAssetsTabDefaultSortCriteria;
  }

  static getCollectionAssetGlobalSortOrder() {
    return window.gs.collectionAssetsTabDefaultSortOrder;
  }

  /**
   *
   * @param {number} collectionId
   * @param {Function.<CollectionParametersObject>} onResult
   * @param {string} uniqueId
   * @return {Promise}
   */
  static getCollectionParameters(collectionId: number, onResult: Function, uniqueId: ?string = null): Promise {
    //Note: We are use GetCollectionparams command to get collection params, but actually, params are stored as metdata.
    //This command GetCollectionparams is zero auth command, thats why we are not using getmetadata command. -Om
    const query = new GetCollectionParametersQuery();
    query.message = new GetCollectionParametersMessage().setCollectionId(collectionId).setPrivateLink(uniqueId);
    //Todo note set progress to true. Like run(true) below. It is causing infite loop when private link is shared. - Om 2nd Oct 2017
    const promise = query.run(false).then(
      function (collectionParameters: CollectionParametersObject) {
        return onResult(collectionParameters, null);
      },
      function (errorId) {
        return onResult(null, errorId);
      }
    );
    return promise;
  }

  /**
   * @param {HashMap} collectionParameters
   * @return {boolean}
   */
  static isReadOnlyLink(collectionParameters: HashMap) {
    return (
      CollectionUtil.COLLECTION_PARAMETER_VALUES.ANYONE_WITH_LINK_CAN_VIEW ==
      collectionParameters.get(CollectionUtil.COLLECTION_PARAM_KEYS.SHARING)
    );
  }

  /**
   * @param {HashMap} collectionParameters
   * @return {boolean}
   */
  static canCommentWithLink(collectionParameters: HashMap) {
    return (
      CollectionUtil.COLLECTION_PARAMETER_VALUES.ANYONE_WITH_LINK_CAN_COMMENT ==
      collectionParameters.get(CollectionUtil.COLLECTION_PARAM_KEYS.SHARING)
    );
  }

  /**
   * @param {HashMap} collectionParameters
   * @return {boolean}
   */
  static isLoginRequiredForLink(collectionParameters: HashMap) {
    return CollectionUtil.isLinkSharingInviteOnly(collectionParameters);
  }

  /**
   * @param {HashMap} collectionParameters
   * @return {boolean}
   */
  static isLinkSharingInviteOnly(collectionParameters: HashMap) {
    return (
      CollectionUtil.COLLECTION_PARAMETER_VALUES.INVITE_ONLY ==
      collectionParameters.get(CollectionUtil.COLLECTION_PARAM_KEYS.SHARING)
    );
  }

  /**
   * @param {HashMap} collectionParameters
   * @return {boolean}
   */
  static isLinkSharingDisabled(collectionParameters: HashMap) {
    return (
      CollectionUtil.COLLECTION_PARAMETER_VALUES.SHARING_DISABLED ==
      collectionParameters.get(CollectionUtil.COLLECTION_PARAM_KEYS.SHARING)
    );
  }

  /**
   * @param {HashMap} collectionParameters
   * @return {boolean}
   */
  static isLinkSharingPasswordProtected(collectionParameters: HashMap) {
    return (
      collectionParameters.get(CollectionUtil.COLLECTION_PARAM_KEYS.PASSWORD_PROTECTED) == 'true'
    );
  }

  /**
   *
   * @param {ZmCollection} collection
   */
  static isLoggedInUserCollectionsCreator(collection: ZmCollection): boolean {
    const creator: string = collection.getCreator();
    return Authenticator.AUTH_DATA.isMe(creator);
  }

  static getCurrentUserCollectionPermission(collectionId: number) {
    const query = new GetZmCollectionUsersQuery();
    query.message = collectionId;
    return query.run().then(function (response) {
      /**
       * @type {CollectionUsersInfo}
       */
      const resp = response;

      let permission = CollectionUtil.PERMISSIONS.NONE;

      /**
       * @type {Array.<CollectionUserEntry>}
       */
      const users = resp.getCollectionUsers();

      if (users) {
        const me = _.find(users, function (item) {
          return Authenticator.AUTH_DATA.isMe(item.getUserId());
        });
        if (me) {
          const permissionLevel = me.getCollectionPermissionLevel();
          permission = _.find(Object.keys(CollectionUtil.PERMISSIONS), function (p) {
            return CollectionUtil.PERMISSIONS[p] === permissionLevel;
          });
        }
      }
      return permission;
    });
  }

  static getMemberUserPermissions(collection: ZmCollection): Permissions {
    return {
      canResolveComments: CollectionSettingsUtil.canResolveComments(collection),
      canAddPeople: CollectionSettingsUtil.canShare(collection),
      canAddTags: CollectionSettingsUtil.canAddTag(collection),
      canAddAssets: CollectionSettingsUtil.canAddAssets(collection),
      isAdmin: CollectionSettingsUtil.isOwnerOrSuperAdminOrAdmin(collection),
      canEditAllComment: CollectionSettingsUtil.isOwnerOrSuperAdmin(collection),
      canRemovePeople: CollectionSettingsUtil.canRemovePeople(collection),
      canViewComments: CollectionSettingsUtil.canViewComments(collection),
      canWriteComments: CollectionSettingsUtil.canWriteComments(collection),
      canFavoriteAndDeleteTag: CollectionSettingsUtil.canFavorite(collection),
      canChangeParameters: CollectionSettingsUtil.canChangeParameters(collection),
      canRenameCollection: CollectionSettingsUtil.canRenameCollection(collection),
      canRemoveAssets: CollectionSettingsUtil.canRemoveAssets(collection),
      canApproveOrReject: CollectionSettingsUtil.canApproveOrReject(collection),
      canShowSpotLightAction: CollectionSettingsUtil.canShowSpotLightAction(collection),
      canShowPopOver: CollectionSettingsUtil.canShowPopOver(collection),
      canViewExpiredCollection: CollectionSettingsUtil.isOwnerOrSuperAdminOrAdmin(collection)
    };
  }

  static getUserPermissions(collection: ZmCollection): any {
    return CollectionUtil.getMemberUserPermissions(collection);
  }

  // Start Permission based methods
  /**
   * @public
   * @return {Boolean}
   */
  static isNotLinkUrl() {
    return !CollectionUtil.isLink();
  }

  /**
   * @public
   * @return {Boolean} whether collection is a link
   */

  static isLink() {
    return window.gs.linkSharingData !== null && window.gs.linkSharingData !== undefined;
  }

  //END --- PERMISSIONSSSS *************************

  /**
   *
   * @param {Number} cid
   * @param {Array.<RepoItem>} repoItems
   */
  static deleteCollectionAssets(cid: number, repoItems: Array<RepoItem>) {
    if (!Array.isArray(repoItems)) {
      repoItems = [repoItems];
    }

    const fuidRrnInfos = repoItems.map((repoItem) => {
      let fuidRrnInfo = new FuidRrnInfo();
      fuidRrnInfo.setBid(repoItem.getBid());
      fuidRrnInfo.setFuid(repoItem.getFuid());
      fuidRrnInfo.setRrn(repoItem.getRrn());
      return fuidRrnInfo;
    });

    return new DeleteZmCollectionAssets(cid, fuidRrnInfos).run();
  }

  /**
   *
   * @param {RepoItem} asset
   * @param {Function<AddFavItemsResp,ErrorId>} onResult
   */
  static addToFav(asset: RepoItem, onResult: Function) {
    new AddFavItem()
      .setAssetAsFav(asset)
      .run()
      .then(
        function (
          /**
           * @type {AddFavItemsResp}
           */ resp
        ) {
          onResult(resp, null);
        },
        function (error) {
          onResult(null, error);
        }
      );
  }

  /**
   *
   * @param {RepoItem} asset
   * @param {Function<AddFavItemsResp,ErrorId>} onResult
   */
  static removeFromFav(asset: RepoItem, onResult: Function) {
    new AddFavItem()
      .setAssetAsFav(asset)
      .setRemove()
      .run()
      .then(
        function (
          /**
           * @type {AddFavItemsResp}
           */ resp
        ) {
          onResult(resp, null);
        },
        function (error) {
          onResult(null, error);
        }
      );
  }

  /**
   * Creates the LsColleciton query and executes it.
   * Loads the result in window global state.
   */
  static async loadCollectionsInView(collectionId: number = CollectionUtil.getBaseCollectionId(), fetchFullList = false,
    sortBy = CollectionUtil.SORT_PARAMS.DEFAULT_SORT_CRITERIA) {
    const lsCollections = new LsCollections();
    lsCollections.setPageLimit(fetchFullList ? 0 : CollectionUtil.PAGE_LIMIT);
    lsCollections.setCollectionId(collectionId);
    lsCollections.setFetchFullList(fetchFullList);
    lsCollections.setOnlyBins(ViewUtil.isBrowseSubTabActive());
    /**
     * @type {HashMap}
     */
    const map = window.gs.collectionSelectedFilter;
    if (map) {
      map.forEach((key, value) => {
        lsCollections.setCollectionFilters(key, value.toArray());
      });
    }
    lsCollections.setSortBy(CollectionUtil.getGlobalSortCriteria(), CollectionUtil.getGlobalSortOrder());
    if (StringUtil.isNotEmpty(window.gs.collections.searchvalue))
      lsCollections.setSearchValues([window.gs.collections.searchvalue]);
    await lsCollections
      .run()
      .then(async (response: LsZmCollectionsResponse) => {
        let totalEntries = response.getTotalEntries() > 0 ? response.getTotalEntries() : 0;
        let collectionList = [];
        if (collectionId <= 0) {
          collectionList = response.getCollections()
            .filter(coll => coll && coll.getParentId() <= 0)
            .map((r) => r);
        } else {
          let collection = response.getCollections() ? response.getCollections()[0] : null;
          if (collection != null && this.isBinCollection(collection)) {
            for (const childCollectionId of collection.getChildCollections()) {
              let childCollection = response.getCollections().find(coll => coll && coll.getCollectionId() == childCollectionId);

              if (!childCollection || childCollection.getCollectionId() != childCollectionId) {
                let childResponse = await CollectionUtil.listCollections(childCollectionId, false, sortBy);
                childCollection = childResponse.getCollections() ? childResponse.getCollections()[0] : null;
              }

              if (childCollection && childCollection.getCollectionId() > 0) {
                collectionList.push(childCollection);
              }
            }
          }
        }
        if (collectionList.length > 0)
          Store.put(COLLECTION_ID, collectionId);

        CollectionUtil.setCollectionsInGlobalState(collectionList, totalEntries);
      })
      .catch(function (errorId) {
        if (collectionId > 0) {
          CollectionUtil.IS_COLLECTION_PERMISSION_ERROR = true;
          window.setError(errorId.toString());
        }
        CollectionUtil.setCollectionsInGlobalState(null, 0);
      });
  }

  static getLdapRealm() {
    new GetCredentialsQuery(Authenticator.AUTH_DATA.username, Authenticator.AUTH_DATA.cookie).run().then(
      (resp) => {
        window.gs.serverRealm = resp.getServerRealm();
      },
      (error) => { }
    );
    return window.gs.serverRealm;
  }

  static isLdapRealm() {
    return window.gs.serverRealm === this.EXT_LDAP_REALM;
  }

  /**
   *
   * @param {Function.<Array.<LiveDrawEntry>,ErrorId>} callback
   */
  static getListOfLivedraws(callback: Function) {
    new ListLiveDrawsQuery().run().then(
      function (response) {
        let liveDrawEntries = undefined;
        /**
         * @type {ListLiveDrawsResponse}
         */
        const listLiveDrawResponse = response;
        if (listLiveDrawResponse) {
          liveDrawEntries = listLiveDrawResponse.getLiveDraws();
        }
        callback(liveDrawEntries, undefined);
      },
      function (error) {
        callback(undefined, error);
      }
    );
  }

  /**
   *
   * @param {number} collectionId
   * @param {LiveDrawEntry} liveDrawEntry
   * @param {Function.<number,ErrorId>} callback
   */
  static createLiveDraw(
    collectionId: number,
    liveDrawEntry: LiveDrawEntry,
    tmpBaseImageId: string,
    callback: Function
  ) {
    const query = new CreateLiveDrawQuery();
    query.message = new CreateLiveDrawMessage().setCollectionScope(new CollectionScope().setCollectionId(collectionId));
    query.message.setLiveDrawEntry(liveDrawEntry);
    query.message.setTmpSvgId(tmpBaseImageId);
    query.run().then(
      function (response) {
        let liveDrawId = 0;
        /**
         * @type {CreateLiveDrawResponse}
         */
        const createLiveDrawResponse = response;
        if (createLiveDrawResponse) {
          liveDrawId = createLiveDrawResponse.getLiveDrawId();
        }
        callback(liveDrawId);
      },
      function (error) {
        callback(undefined, error);
      }
    );
  }

  /**
   *
   * @param {number} collectionId
   * @returns {Promise.<boolean,ErrorId>}
   */
  static async createCollectionLink(collectionId: number) {
    const query = new CreateCollectionLinkQuery();
    query.message = collectionId;
    query.run();
  }

  static isLiveDrawEnabled(callback: Function) {
    const query = new GetLiveDrawSpec();
    query.run().then(
      function (response) {
        /**
         * @type {LiveDrawSpecResponse}
         */
        const createLiveDrawResponse = response;
        if (createLiveDrawResponse) {
          callback(createLiveDrawResponse.isIsLiveDrawEnabled());
        }
      },
      function (error) {
        console.error(error);
        callback(false);
      }
    );
  }

  static isExpired(collectionMetadata: HashMap) {
    if (!collectionMetadata) {
      return false;
    }

    const key = CollectionUtil.COLLECTION_PARAM_KEYS.DUE_DATE;
    const arr = collectionMetadata.get(key);
    if (!arr) {
      return false;
    }

    if (!Array.isArray(arr)) {
      return false;
    }

    const value = arr[0];
    if (typeof value !== 'string') {
      return false;
    }

    // TODO: more checks?

    const millis = parseInt(value, 10);
    if (isNaN(millis)) {
      // Something went wrong. Let them through?
      return false;
    }

    return Date.now() > millis;
  }

  static setMultipleCollectionSettings(collectionId: number, userId: string, propName2ValueMap: HashMap) {
    const setCollectionSettings = new SetCollectionSettings(collectionId, userId, propName2ValueMap);
    return setCollectionSettings.setSettingsOfCollection();
  }

  static setCollectionSetting(collectionId: number, userId: string, propName: string, propValue: string) {
    const setCollectionSettings = new SetCollectionSettings(collectionId, userId);
    setCollectionSettings.setPropName2PropValue(propName, propValue);
    return setCollectionSettings.setSettingsOfCollection();
  }

  static getCollectionSettings(
    collectionId: number,
    userId: string,
    doNotUseAuthenticator: boolean = false
  ): Promise<HashMap> {
    const query: GetCollectionSettings = new GetCollectionSettings(collectionId, userId);
    if (doNotUseAuthenticator) {
      query.doNotUserAuthenticator();
    }
    return new Promise((resolve, reject) => {
      query
        .getCollectionSettings()
        .then((resp) => {
          const cid2Uid2Settings = resp.getCid2Uid2Settings();
          if (!cid2Uid2Settings) return resolve();
          const uid2Settings = cid2Uid2Settings.get(collectionId);
          if (!uid2Settings) return resolve();
          const uid2SettingsMap = uid2Settings.getUid2SettingsMap();
          if (!uid2SettingsMap) return resolve();
          const propName2Value = uid2SettingsMap.get(userId);
          if (!propName2Value) return resolve();
          const propName2ValueMap = propName2Value.getPropName2ValueMap();
          debug('[getCollectionSettings()] propName2ValueMap: ', propName2ValueMap);
          if (propName2ValueMap) {
            resolve(propName2ValueMap);
          }
        })
        .catch((error) => {
          debug('[getCollectionSettings()] error: ', error);
          return reject(error);
        });
    });
  }

  static deleteCollectionSetting(collectionId: number, userId: string, propName: string) {
    const setCollectionSettings = new SetCollectionSettings(collectionId, userId);
    setCollectionSettings.setPropName2PropValue(propName, null);
    return setCollectionSettings.setSettingsOfCollection();
  }

  static deleteMultipleCollectionSettings(collectionId: number, userId: string, propName2ValueMap: HashMap) {
    const setCollectionSettings = new SetCollectionSettings(collectionId, userId, propName2ValueMap);
    return setCollectionSettings.setSettingsOfCollection();
  }

  static findCollectionSortSettings(collectionId: number): Object {
    const settingsArray: Array = window.gs.collectionAssetsTabSortSettings;
    const collectionSortSettings: Object = _.find(settingsArray, (obj) => {
      return obj.collectionId == collectionId;
    });
    return collectionSortSettings;
  }

  static getTotalAssetsLabelAndTooltip(collection: ZmCollection) {
    let tooltip = undefined;
    let totalAssetLabel = undefined;
    const totalAssets = collection.getTotalAssets();
    const assetCountSuffix: string = collection.isHasDynamicFilters() ? '+' : '';

    if (collection.isDynamic()) {
      tooltip = undefined;
      totalAssetLabel = undefined;
    } else if (totalAssets === 0 || totalAssets === 1) {
      tooltip = t('COUNT_ASSET_INSIDE_COLLECTION', {
        count: totalAssets.toString() + assetCountSuffix
      });
      totalAssetLabel = totalAssets + assetCountSuffix + ' ' + t('ASSET');
    } else {
      tooltip = t('COUNT_ASSETS_INSIDE_COLLECTION', {
        count: totalAssets.toString() + assetCountSuffix
      });
      totalAssetLabel = totalAssets + assetCountSuffix + ' ' + t('ASSETS');
    }
    return {
      totalAssetLabel,
      tooltip
    };
  }

  static getResolvedCommentsCounts(collection: ZmCollection): number {
    const v = this.getCollectionMetadataValue(collection, this.COLLECTION_PARAM_KEYS.RESOLVED_COMMENTS_COUNTS);
    return v ? _.toNumber(v) : 0;
  }

  static getNumberOfRejections(collection: ZmCollection): number {
    const v = this.getCollectionMetadataValue(collection, this.COLLECTION_PARAM_KEYS.NUMBER_OF_REJECTIONS);
    return v ? _.toNumber(v) : 0;
  }

  static getNumberOfApprovals(collection: ZmCollection): number {
    const v = this.getCollectionMetadataValue(collection, this.COLLECTION_PARAM_KEYS.NUMBER_OF_APPROVALS);
    return v ? _.toNumber(v) : 0;
  }

  static getTotalComments(collection: ZmCollection): number {
    const v = this.getCollectionMetadataValue(collection, this.COLLECTION_PARAM_KEYS.TOTAL_COMMENTS);
    return v ? _.toNumber(v) : 0;
  }

  static getUnreadCommentsCount(collection: ZmCollection): number {
    const v = this.getCollectionMetadataValue(collection, this.COLLECTION_PARAM_KEYS.UNREAD_COMMENTS_COUNT);
    return v ? _.toNumber(v) : 0;
  }

  static getCollectionMetadataValue(collection: ZmCollection, propertyName: string): ?string {
    const map: HashMap = collection.getMetadata();
    return map.get(propertyName);
  }

  static async listCollections(collectionId, fetchFullList = false, sortBy = CollectionUtil.SORT_PARAMS.DEFAULT_SORT_CRITERIA,
    collectionFiltersMap) {
    const lsCollections = new LsCollections();
    lsCollections.setCollectionId(collectionId);
    lsCollections.setFetchFullList(fetchFullList);
    lsCollections.setSortBy(sortBy);
    if (collectionFiltersMap && collectionFiltersMap.size() > 0)
      lsCollections.setCollectionFilters(collectionFiltersMap);
    return lsCollections.run();
  }

  static isBinCollection(collection): boolean {
    return collection.getCollectionId() <= 0 || collection.isBin();
  }

  static isAssetCollection(collection): boolean {
    return !CollectionUtil.isBinCollection(collection);
  }

  static getBins() {
    let collections = Store.get(COLLECTIONS);
    return collections.filter(CollectionUtil.isBinCollection);
  }

  static getAssetCollections() {
    let collections = Store.get(COLLECTIONS);
    return collections.filter(CollectionUtil.isAssetCollection);
  }

  static async calculateCollectionPwd(collection) {
    let pwd_collections = [collection.getCollectionId()];
    let node = collection;
    while (node && node.getParentId() > 0) {
      if (node) {
        pwd_collections.push(node.getParentId());
      }
      node = await CollectionUtil.fetchCollection(node.getParentId());
    }
    pwd_collections = pwd_collections.reverse();
    return pwd_collections;
  }

  static async fetchCollection(collectionId: number) {
    const collectionResp: LsZmCollectionsResponse = await CollectionUtil.getCollectionById(collectionId);
    const collection = collectionResp ? collectionResp.getCollections().find(c => c.getCollectionId() === collectionId) : null;
    return collection;
  };

  static async switchToCollection(collection, pwd_collections = null, switchToBrowseSubTab = false) {
    //console.log("switchToCollections() started.", collection);
    if (ViewUtil.isBrowseSubTabActive() || switchToBrowseSubTab
      || (collection && collection.getCollectionId() == CollectionUtil.ROOT_COLLECTION_ID)) {
      //console.log("[switchToCollections()] browse tab found.");
      if (!pwd_collections && collection.getCollectionId() > 0) {
        pwd_collections = await CollectionUtil.calculateCollectionPwd(collection);
      }

      let args = { ...window.ARGS };
      args.activeSubTab = SUBTAB.BROWSE.KEY;
      ViewUtil.setARGS(args, true);
      ViewUtil.setTitle();
    }
    //console.log("[switchToCollections()] pwd_collections : ", pwd_collections);

    if (CollectionUtil.isBinCollection(collection)) {
      //console.log("[switchToCollections()] browse tab found.");
      ViewUtil.switchToBinId(collection.getCollectionId(), SUBTAB.BROWSE.KEY, pwd_collections);
      await CollectionUtil.loadCollectionsInView(collection.getCollectionId());
      Store.put(SELECTED_COLLECTION, collection);
      Store.put(COLLECTION_ID, collection.getCollectionId());
      //console.log("[switchToCollections()] switching done");
    }
    else {
      //console.log("[switchToCollections()] inside browse collection : ", collection.getCollectionId());
      ViewUtil.switchToCollectionId(collection.getCollectionId(), ViewUtil.getActiveSubTab(), pwd_collections);
      Store.put(SELECTED_COLLECTION, collection);
      Store.put(COLLECTION_ID, CollectionUtil.getBaseCollectionId());
    }
  }

  static getActiveCollectionId() {
    if (window.ARGS.collectionId) {
      return window.ARGS.collectionId;
    }
    else if (Store.get(COLLECTION_ID) >= 0) {
      return Store.get(COLLECTION_ID);
    }
    else {
      return CollectionUtil.getBaseCollectionId();
    }
  }

  static downloadAsset = async (asset: RepoItem) => {
    try {
      debug('[downloadAsset()] asset: ', asset);
      toast(t('DOWNLOAD_BEGIN_SHORTLY'));
      //toast('Your download will begin shortly');

      const job = (this._pollAndDownloadJob = await PollAndDownloadJob.create([asset]));

      await job.promise;
      debug('[downloadAsset()] success');
      toast(t('DOWNLOAD_COMPLETE'));
    } catch (err) {
      debug('[downloadAsset()] error: ', err);
      toast(getErrorMessage(err));
    } finally {
      this._pollAndDownloadJob = null;
      Store.put(DOWNLOAD_JOBS, []);
    }
  };

  static getMetadataMapForArchive(currentStatus) {
    let hashMap = new HashMap();
    let collMetadata = new CollMetadata();
    let valueList = new ValueList();
    valueList.setValues([CollectionUtil.COLLECTION_ARCHIVED_KEY]);
    hashMap.put(CollectionUtil.COLLECTION_STATUS_KEY, valueList);
    let valueList2 = new ValueList();
    valueList2.setValues([currentStatus]);
    hashMap.put(CollectionUtil.COLLECTION_PREVIOUS_STATUS_KEY, valueList2);
    collMetadata.setCollMetadata(hashMap);
    return collMetadata;
  };

  static getMetadataMapForRestore(previousStatus) {
    let hashMap = new HashMap();
    let collMetadata2 = new CollMetadata();
    let valueList = new ValueList();
    valueList.setValues([previousStatus]);
    hashMap.put(CollectionUtil.COLLECTION_STATUS_KEY, valueList);
    collMetadata2.setCollMetadata(hashMap);
    return collMetadata2;
  };

}

export const actionOnCollectionPermissionError = function () {
  if (CollectionUtil.IS_COLLECTION_PERMISSION_ERROR) {
    CollectionUtil.IS_COLLECTION_PERMISSION_ERROR = false;
    ViewUtil.switchToHomeTab();
  }
};

export function extractCollectionsFromCIds(collections: Array<ZmCollection> = [], cIds: Array<number> = []) {
  return collections.filter((collection: ZmCollection) => cIds.includes(collection.getCollectionId()))
}
